import { atom } from '@cloudio-saas/statex';

interface HowTo {
  howToUid: string;
  appUid: string;
}

export const followOnHowToAtom = atom<HowTo | undefined>({
  path: ['howto', 'followOn', 'data'],
  defaultValue: undefined,
  urlParam: true,
});

export const followOnHowToPositionAtom = atom<'right' | 'left'>({
  path: ['howto', 'followOn', 'position'],
  defaultValue: 'right',
  urlParam: true,
});

export const followOnHowToMinimizedAtom = atom({
  path: ['howto', 'followOn', 'minimized'],
  defaultValue: false,
  urlParam: true,
});
